export interface FetcherParams {
	method: string;
	headers: Record<string, string>;
}
export interface DefaultParams {
	method?: string;
	headers?: Record<string, string>;
	postData?: PostData;
}

export type PostData = null | string | Record<string, any>;

export abstract class AbstractFetcher {
	protected defaultParams?: DefaultParams = {};

	/**
	 * Set default params to request like a method, body (pot data) and headers
	 * (headers will merge with previous defined default headers)
	 */
	setDefaultParams(defaultParams: DefaultParams) {
		this.defaultParams = {
			...this.defaultParams,
			...defaultParams,
			headers: {...this.defaultParams?.headers, ...defaultParams.headers},
		};
	}

	abstract fetch<TResponse = any>(
		url: string,
		postData?: PostData,
		params?: Partial<FetcherParams>,
	): Promise<TResponse>;

	protected prepareParams(clientPostData: PostData, params: Partial<FetcherParams>) {
		const headers = {...this.defaultParams?.headers, ...params.headers};
		const method = params.method || this.defaultParams?.method || 'GET';
		let postData = clientPostData ?? this.defaultParams?.postData ?? undefined;

		// Prepare the post-data
		if (typeof postData === 'string') {
			// Plain text body
			headers['Content-Type'] = 'text/plain';
		} else if (postData) {
			headers['Content-Type'] = 'application/json';
			// Convert a serializable object to a JSON string
			postData = JSON.stringify(postData);
		}

		return {headers, method, postData};
	}
}
